import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import moment from 'moment'
import officeImg from "../../../assets/office.png"
import UserImage from "../../../assets/user.png"
import CountrySelect from '../../../components/CountrySelect'
import { Country } from 'country-state-city'

const CreateShelfAd = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { name } = useParams()

    // Guard against direct navigation without state
    const { ad = null, adType = 'shelf' } = location.state || {}


    // Logic Fix: Use optional chaining to prevent crash if products are missing
    const [focusedImg, setFocusedImg] = useState(ad?.products?.[0]?.files?.[0] || null)
    const [allCountries, setAllCountries] = useState([])
    const [selectedCountries, setSelectedCountries] = useState([])
    const [budget, setBudget] = useState(1000)
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [audience, setAudience] = useState("general")
    const [isSubmitting, setIsSubmitting] = useState(false)

    // console.log(ad)

    useEffect(() => {
        // Sync focused image when ad data is available
        if (ad?.products?.[0]?.files?.[0]) {
            setFocusedImg(ad.products[0].files[0])
        }
    }, [ad])

    const today = new Date().toISOString().split("T")[0]

    useEffect(() => {
        setAllCountries(Country.getAllCountries().map(c => ({ value: c.isoCode, label: c.name })))
    }, [])

    const toggleCountry = (country) => {
        const exists = selectedCountries.some(c => c.value === country.value)
        if (exists) {
            setSelectedCountries(prev => prev.filter(c => c.value !== country.value))
        } else {
            setSelectedCountries(prev => [...prev, country])
        }
    }

     useEffect(() => {
            if (!startDate || !endDate) return;
    
            const start = new Date(startDate);
            const end = new Date(endDate);
    
            if (end < start) return;
    
            const days =
                Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
    
            setBudget(days * 250);
        }, [startDate, endDate]);

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!budget) {
            toast.error('Daily budget is required')
            return
        }

        try {
            setIsSubmitting(true)
            // Logic Fix: Ensure we pass the ID and map country objects to values if your backend expects strings
            const response = await api.post(`/stores/${name}/manage/promotions/shelves`,
                {
                    adId: ad?._id,
                    selectedCountries: selectedCountries.map(c => c.value),
                    budget,
                    audience,
                    startDate,
                    endDate,
                    entity: ad.storeId,
                    adType
                }
            )


            if (!response?.data) {
                toast.error('Ad not saved. Please try again.')
                return
            }

            toast.success('Ad saved please pay to activate it')
            const savedAd = response.data.ad || response.data
            navigate(`/b/manage/${name}/promotions/${savedAd._id}/payments`, { state: { ad: savedAd } })
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message || 'Ad not saved')
        } finally {
            setIsSubmitting(false)
        }
    }

    if (!ad) {
        return <div className="create-ad-page"><p>Invalid ad context.</p></div>
    }

    return (
        <div className="">
            <div className="create-ad-title">
                <h3>Promote This Shelf</h3>
            </div>
            <div className="create-ad-page">

                <form onSubmit={handleSubmit} className="create-ad-form">
                    <div className="ad-content">
                        <div className='post'>
                            <div className='org-post'>
                                <div className="org-post-header">
                                    <div className="profile-details">
                                        <img
                                            src={ad.store?.profileImage || officeImg}
                                            alt=""
                                            className="userpost-profile-img"
                                        />
                                        <div className="post-data-details">
                                            <p className="post-profile-name">{ad?.store?.name}</p>
                                            <div className="post-dates">
                                                <p>{moment(ad.createdAt).fromNow()}</p>
                                                <p>Audience</p>
                                            </div>
                                        </div>
                                    </div>
                                    {ad.createdBy?._id && (
                                        <Link to={`/user/${ad.createdBy._id}`}>
                                            <div className="org-post-user">
                                                <div className="org-post-userimg">
                                                    <img src={ad.createdBy?.profilePic || UserImage} alt='' />
                                                </div>
                                                <div className="org-post-username">
                                                    <h3>{ad.createdBy?.firstname} {ad.createdBy?.lastname}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    )}
                                </div>

                                <div className="post-body">
                                    {/* Logic Fix: ad objects usually don't have a value for textarea unless you want it editable */}
                                    <p> {ad.description}</p>

                                    {ad.products?.length > 0 && (
                                        <div className="postcard-images">
                                            {/* Fix: Check type and focusedImg existence safely */}
                                            {ad.products[0]?.files?.[0]?.type === 'image' && focusedImg && (
                                                <div className="post-images">
                                                    <div className="focused-image">
                                                        <img src={focusedImg.url} alt="focused" />
                                                    </div>
                                                    <div className="image-list">
                                                        <div className='image-selector'>
                                                            {ad.products.map((product, i) => (
                                                                <div
                                                                    className='image-selector-wrapper'
                                                                    key={i}
                                                                    onClick={() => setFocusedImg(product?.files?.[0])}>
                                                                    <img src={product?.files?.[0]?.url} alt="thumb" />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Fix: Check for video in files array safely */}
                                            {ad.files?.[0]?.type === 'video' && (
                                                <div className='video-container'>
                                                    <video controls>
                                                        <source src={ad.files[0].url} type='video/mp4' />
                                                    </video>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Budget in Ksh *</label>
                        <input type="number" min="1" name="budget" value={budget} onChange={(e) => setBudget(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label>Dates *</label>
                        <p>start</p>
                        <input
                            type="date"
                            name="startDate"
                            min={today}
                            value={startDate}
                            required
                            onChange={(e) => {
                                const value = e.target.value;
                                setStartDate(value);
                                if (endDate && endDate < value) {
                                    setEndDate(value);
                                }
                            }}
                        />

                        <p>end</p>
                        <input
                            type="date"
                            name="endDate"
                            required
                            min={startDate || today}
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label>Target Audience</label>
                        <select name="audience" value={audience} onChange={(e) => setAudience(e.target.value)}>
                            <option value="general">General</option>
                            <option value="youth">Youth</option>
                            <option value="professionals">Professionals</option>
                            <option value="business">Business</option>
                        </select>
                        <div className="country">
                            <CountrySelect />
                        </div>
                        <div className="countries">
                            {/* Logic suggestion: consider .slice(0, 20) or a search bar if this list is too long */}
                            {allCountries.map(c => (
                                <button type="button" key={c.value} className={selectedCountries.some(s => s.value === c.value) ? "country active" : "country"} onClick={() => toggleCountry(c)}>
                                    {c.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="payment-section">
                        <h4>Payment</h4>
                        <p className="payment-summary">Amount to be charged: <strong>Ksh{Number(budget) || 0}</strong></p>
                    </div>

                    <div className="form-actions">
                        <button type="submit" disabled={isSubmitting}>
                            {isSubmitting ? 'Processing...' : 'Save'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default CreateShelfAd